export default __webpack_public_path__ + "static/media/27t.216db1d3.jpg";